import {TLevelObject} from "../../config/types";
import {Vec2} from "../core/Vec2.js";
import {
  SimulationEvent,
  SimulationEventType,
} from "../manager/SimulationManager.js";
import {Player} from "../player/Player.js";
import {attractionStrength} from "../utils/AttractionFunction";
import {isPointInsideEllipse} from "../utils/EllipseUtils.js";
import GameObject from "./GameObject.js";

const STRENGTH = 120;

class Attractor extends GameObject {
  public readonly position: Vec2;
  public readonly rotation: number;
  public readonly scale: Vec2;

  constructor(position: Vec2, rotation: number, scale: Vec2) {
    super();
    this.position = position;
    this.rotation = rotation;
    this.scale = scale;
  }

  static create(obj: TLevelObject): Attractor {
    const position = new Vec2(obj.position[0], obj.position[1]);
    return new Attractor(
      position,
      obj.rotation,
      new Vec2(obj.scale[0], obj.scale[1]),
    );
  }

  /**
   * Checks if the player is within the attractor's zone and returns a force event.
   */
  public process(player: Player): SimulationEvent[] {
    const radiusX = this.scale.x * 0.5;
    const radiusY = this.scale.y * 0.5;

    if (
      isPointInsideEllipse(
        player.currentPosition,
        this.position,
        this.rotation,
        {
          rx: radiusX,
          ry: radiusY,
        },
        player.radius,
      )
    ) {
      const distance = player.currentPosition.distanceTo(this.position);
      if (distance === 0) return [];

      const strength = attractionStrength(distance, STRENGTH);

      const impulse = this.position
        .clone()
        .sub(player.currentPosition)
        .normalize()
        .mul(strength);

      return [
        {
          type: SimulationEventType.PlayerInAttractorZone,
          player,
          impulse: impulse,
        },
      ];
    }

    return [];
  }
}

export default Attractor;
